import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import DataExtractorGrid from '../components/Grid';
import { DataExtractorProvider } from '../store';

import DataExtractorFormLayout from './Form';

export default function DataExtractorGridLayout() {
  return <DataExtractorProvider>
    <DataExtractorGrid />
    <Router>
      <PrivateRoute path="/settings/data-extractors/add" component={DataExtractorFormLayout} />
    </Router>
  </DataExtractorProvider>;
}
